export default "__VITE_ASSET__edf1cb0f__"